import * as React from 'react';
import {Box, Grid, Typography} from '@mui/material';
import {Edit, FileField, FileInput, NumberInput, SimpleForm, useRecordContext, useResourceContext} from 'react-admin';
import {CustomToolbar} from '../../components/customtoolbar/customToolbar.component';
import {RiskCategoryIconPreview} from './risk-category-icon-preview.component';


const CategoryIdentity = () => {
  const record = useRecordContext<any>();
  return (
    <Box mb={2}>
      <Typography variant="h6">{record?.displayName}</Typography>
    </Box>
  );
};

export const RiskCategoryEdit = () => {
  const resource = useResourceContext();
  const record = useRecordContext();

  return (
    <Edit resource={resource} id={record?.id}>
      <SimpleForm toolbar={<CustomToolbar noDelete />}>
        <CategoryIdentity />
        <Grid container width="100%" spacing={2}>
          <Grid item xs={12}>
            <NumberInput
              source="sortWeight"
              helperText="Störst visas först."
              sx={{width: '16rem'}}
            />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" flexDirection="column" gap={1}>
              <Typography variant="body2">Nuvarande ikon</Typography>
              <RiskCategoryIconPreview />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <FileInput
              source="iconUpload"
              label="Ersätt ikon (SVG)"
              accept="image/svg+xml"
              maxSize={100 * 1024}>
              <FileField source="src" title="title" />
            </FileInput>
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
